import { Component, Inject, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PaymentCardTypes } from './paymentcard.model';
import { PaymentCardFormDialogData } from './paymentcard-form.component';

@Component({
    selector: 'convfact-paymentcard',
    templateUrl: './paymentcard.component.html',
    styleUrls: ['./paymentcard-form.component.css'],
    standalone: false
})
export class PaymentCardComponent {
  paymentCardUid: string | null = null;
  paymentCardType: number;

  constructor(
    private router: Router,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: PaymentCardFormDialogData,
  ) {
    if (data) {
      this.paymentCardUid = data.uid || null;
      this.paymentCardType = data.paymentCardType;
      return;
    }
    this.paymentCardType = this.router.url.includes('/debitcard')
      ? PaymentCardTypes.Tarjeta_Debito
      : PaymentCardTypes.Tarjeta_Credito;
  }

  returnToList(): void {
    if (this.data) return;
    this.router.navigate([this.paymentCardType === PaymentCardTypes.Tarjeta_Debito ? '/finance/debitcard' : '/finance/creditcard']);
  }
}
